import { useEffect } from "react";
import Hauller from '../table/Tablehaller';
import Modal from "../modal/Modalholler"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <Modal/>
    <Hauller/>
    
     
     </>
  );
};

export default Dashboard;
